import { Component, h } from 'preact';

class TcrDateInput extends Component
{
    constructor(props)
    {
        super(props);

        this.validateInput = this.validateInput.bind(this);
        this.formatValue = this.formatValue.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onPaste = this.onPaste.bind(this);

        this.state = {
            value: ''
        }
    }

    onPaste(event)
    {
        if (typeof this.props.onPaste == 'function')
        {
            this.ref.blur();
            return this.props.onPaste(event);
        }
    }

    validateInput(event)
    {
        let rawvalue = event.target.value;

        rawvalue = rawvalue.replace(/[^0-9\.]+/g, '');

        let value = '';
        if (rawvalue.match(/^\d{2}\.\d{2}\.\d{4}$/))
        {
            value = rawvalue.replace(/^(\d{2})\.(\d{2})\.(\d{4})$/, '$3-$2-$1');
        }
        else if (rawvalue.match(/^\d{2}\.\d{2}\.\d{2}$/))
        {
            value = rawvalue.replace(/^(\d{2})\.(\d{2})\.(\d{2})$/, '20$3-$2-$1');
        }

        console.log('raw input:' + rawvalue);
        console.log('parsed input:' + value);

        this.setState({
            value: rawvalue
        }, () => {
            this.props.onInput({
                target: {
                    value: value,
                    dataset: {
                        field: this.props.field
                    }
                }
            });
        });
    }

    onFocus()
    {
        let value = '';
        if (typeof this.props.value !== 'undefined' && this.props.value.match(/^\d{4}\-\d{2}\-\d{2}$/))
        {
            value = this.props.value.replace(/^(\d{4})\-(\d{2})\-(\d{2})$/, '$3.$2.$1');
        }

        this.setState({
            value: value,
            focus: true
        });
    }

    onBlur()
    {
        this.setState({
            focus: false
        });
    }

    formatValue()
    {
        let value = '';
        if (this.state.focus)
        {
            value = this.state.value;
        }
        else if (typeof this.props.value !== 'undefined' && this.props.value.match(/^\d{4}\-\d{2}\-\d{2}$/))
        {
            value = this.props.value.replace(/^(\d{4})\-(\d{2})\-(\d{2})$/, '$3.$2.$1');
        }
        return value;
    }

    render()
    {
        return [
            <input ref={dom => { this.ref = dom;}} type="text" value={this.formatValue()} maxlength="10" data-field={this.props.field} onInput={this.validateInput} onFocus={this.onFocus} onBlur={this.onBlur} onPaste={this.onPaste} />,
            //<label class="date"><input type="date" value={this.props.value} /></label>
        ];
    }
}

export { TcrDateInput };